import { RouteType } from "../../../types/RouteType";

const crmDashboardRoute: RouteType = {
  name: "Dashboard",
  path: "/crm/dashboard",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Dashboard",
      enableBackButton: true,
      enableRefreshButton: true,
      component: () => import("./CrmDashboard.Header"),
    },
    body: {
      grayBackground: true,
      component: () => import("./CrmDashboard.Body"),
    },
  },
  group: 'CRM',
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load dashboard data before entering the route
    const store = rootStore.crmDashboardStore as unknown;
    if (
      store &&
      typeof (store as Record<string, unknown>).loadDashboardData === "function"
    ) {
      try {
        await (
          (store as Record<string, unknown>)
            .loadDashboardData as () => Promise<void>
        )();
      } catch (error) {
        console.error("Failed to load CRM dashboard data:", error);
        // Continue with navigation even if data loading fails
      }
    }
    return true;
  },
  onEnter: ({ rootStore }) => {
    // Set up any real-time subscriptions or polling
    const store = rootStore.crmDashboardStore as unknown;
    if (store) {
      // Could set up periodic refresh here
      console.log("Dashboard entered");
    }
  },
};

export default crmDashboardRoute;
